import { useQuery } from '@tanstack/react-query';

import { paymentTypes } from '../types';

import { axios } from '@/libraries/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libraries/react-query';

export const getPayments: paymentTypes.GetPayments = () => {
  return axios.get('/payments');
};

type QueryFnType = typeof getPayments;

type UseGetPaymentsOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useGetPayments = ({ config = {} }: UseGetPaymentsOptions = {}) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['payments'],
    queryFn: getPayments,
  });
};
